(function(){
  function boot(){
    var root=document.querySelector('[data-wm-finder]');
    if(!root)return;

    var state={
      mode:null,
      use:null,
      guests:null,
      feature:null,
      wood:"egal"
    };

    var products=[];

    /*
      Die Metafelder werden außerhalb dieser JavaScript-Datei
      über Liquid in window.WM_FINDER_PRODUCT_META bereitgestellt.
    */
    var productMeta=window.WM_FINDER_PRODUCT_META||{};

    var handles=[
      "chefbrett-schneidebrett-massivholz-saftrille",
      "chefstation-schneidebrett-arbeitsstation-bbq",
      "caterboard-servierbrett-kaese-antipasti-bbq",
      "pitmaster-board-xxl-servierbrett-fleischbrett-bbq",
      "holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq"
    ];

    var hint=root.querySelector('[data-wm-hint]');
    var showBtn=root.querySelector('[data-wm-show-result]');
    var resetBtn=root.querySelector('[data-wm-reset]');
    var summary=root.querySelector('[data-wm-summary]');
    var wrap=root.querySelector('[data-wm-productwrap]');
    var altWrap=root.querySelector('[data-wm-altwrap]');
    var note=root.querySelector('[data-wm-note]');

    if(!showBtn||!resetBtn||!summary||!wrap||!altWrap||!note){
      return;
    }

    function ready(){
      return !!(
        state.mode &&
        state.use &&
        state.guests &&
        state.feature
      );
    }

    function clean(v){
      return String(v||"").toLowerCase();
    }

    function has(t,a){
      return a.some(function(w){
        return t.indexOf(clean(w))>-1;
      });
    }

    function money(v){
      var n=Number(v||0);

      if(n>999){
        n=n/100;
      }

      return n.toLocaleString("de-DE",{
        style:"currency",
        currency:"EUR"
      });
    }

    function esc(s){
      return String(s||"").replace(/[&<>"']/g,function(m){
        return({
          "&":"&amp;",
          "<":"&lt;",
          ">":"&gt;",
          "\"":"&quot;",
          "'":"&#039;"
        }[m]);
      });
    }

    function getText(p){
      return clean([
        p.title,
        p.handle,
        p.collection,
        p.product_type,
        (p.tags||[]).join(" "),
        p.body_html
      ].join(" "));
    }

    function metaText(value){
      if(
        value===null ||
        typeof value==="undefined" ||
        value===""
      ){
        return "";
      }

      if(Array.isArray(value)){
        return value
          .map(function(item){
            return metaText(item);
          })
          .filter(Boolean)
          .join(", ");
      }

      if(typeof value==="object"){
        if(value.label){
          return String(value.label);
        }

        if(value.name){
          return String(value.name);
        }

        if(typeof value.value!=="undefined"){
          return metaText(value.value);
        }

        return "";
      }

      return String(value);
    }

    function getWood(p){
      var t=getText(p);

      if(has(t,["nussbaum"]))return"Nussbaum";
      if(has(t,["eiche"]))return"Eiche";
      if(has(t,["esche"]))return"Esche";
      if(has(t,["ulme"]))return"Ulme";

      return"";
    }

    function getSize(p){
      var txt=[
        p.title,
        p.handle,
        (p.tags||[]).join(" ")
      ].join(" ");

      var m=txt.match(/(\d{2,3})\s*[x×]\s*(\d{2,3})/i);

      if(m){
        return m[1]+"x"+m[2];
      }

      return"";
    }

    function sizeArea(size){
      if(!size)return 0;

      var m=size.match(/(\d{2,3})x(\d{2,3})/);

      if(!m)return 0;

      return Number(m[1])*Number(m[2]);
    }

    function getCollectionLabel(p){
      if(p.collection==="caterboard-servierbrett-kaese-antipasti-bbq"){
        return"CaterBoard";
      }

      if(p.collection==="pitmaster-board-xxl-servierbrett-fleischbrett-bbq"){
        return"Pitmaster Board";
      }

      if(p.collection==="chefbrett-schneidebrett-massivholz-saftrille"){
        return"Chefbrett";
      }

      if(p.collection==="chefstation-schneidebrett-arbeitsstation-bbq"){
        return"Chefstation";
      }

      if(p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq"){
        return"Steak & Burger";
      }

      return"wood & more";
    }

    function normalizeProduct(p,collectionHandle){
      var img="";

      if(p.images&&p.images.length){
        img=typeof p.images[0]==="string"
          ?p.images[0]
          :p.images[0].src;
      }

      if(!img&&p.featured_image){
        img=typeof p.featured_image==="string"
          ?p.featured_image
          :p.featured_image.src;
      }

      var price=0;

      if(p.variants&&p.variants.length){
        price=p.variants[0].price;
      }

      var meta=productMeta[p.handle]||{};

      var item={
        title:p.title,
        handle:p.handle,
        url:"/products/"+p.handle,
        image:img,
        price:price,
        tags:p.tags||[],
        body_html:p.body_html||"",
        product_type:p.product_type||"",
        collection:collectionHandle,
        personen:meta.personen||"",
        bretttyp:meta.bretttyp||"",
        besteWahl:meta.besteWahl||""
      };

      item.wood=getWood(item);
      item.size=getSize(item);
      item.area=sizeArea(item.size);
      item.collectionLabel=getCollectionLabel(item);

      return item;
    }

    function loadProducts(){
      return Promise.all(
        handles.map(function(h){
          return fetch("/collections/"+h+"/products.json?limit=250")
            .then(function(r){
              return r.ok?r.json():{products:[]};
            })
            .then(function(d){
              return{
                collectionHandle:h,
                products:d.products||[]
              };
            })
            .catch(function(){
              return{
                collectionHandle:h,
                products:[]
              };
            });
        })
      ).then(function(groups){
        var seen={};
        products=[];

        groups.forEach(function(group){
          group.products.forEach(function(p){
            if(!seen[p.handle]&&p.handle!=="gravur-service-brett"){
              seen[p.handle]=true;
              products.push(
                normalizeProduct(p,group.collectionHandle)
              );
            }
          });
        });
      });
    }

    function update(){
      if(hint){
        hint.textContent=ready()
          ?"Perfekt – jetzt zeigen wir dir meine Empfehlung."
          :"Wähle die ersten vier Punkte aus. Holz ist optional.";
      }
    }

    root.addEventListener("click",function(e){
      var btn=e.target.closest("button.wm-choice");

      if(!btn)return;

      var group=btn.getAttribute("data-group");
      var value=btn.getAttribute("data-value");

      root
        .querySelectorAll('button.wm-choice[data-group="'+group+'"]')
        .forEach(function(el){
          el.setAttribute("aria-pressed","false");
        });

      btn.setAttribute("aria-pressed","true");
      state[group]=value;

      update();
    });

    function scoreProduct(p){
      var t=getText(p);
      var score=0;
      var reasons=[];

      if(state.wood&&state.wood!=="egal"){
        if(has(t,[state.wood])){
          score+=35;
          reasons.push("Holzoptik passt zu deiner Auswahl");
        }else{
          score-=6;
        }
      }

      if(state.mode==="alltag"&&has(t,[
        "chefbrett","schneidebrett","küche","kueche",
        "alltag","allrounder","40x30","50x30"
      ])){
        score+=60;
        reasons.push("passt gut zum täglichen Vorbereiten");
      }

      if(state.mode==="bbq"&&has(t,[
        "bbq","grill","pitmaster","brisket","pulled pork",
        "fleisch","tranchieren","60x40","70x40","80x40","xxl"
      ])){
        score+=90;
        reasons.push("gemacht für BBQ und große Fleischstücke");
      }

      if(state.mode==="servieren"&&has(t,[
        "servieren","servierbrett","caterboard","snackboard",
        "gäste","gaeste","antipasti","käse","kaese","brotzeit","buffet"
      ])){
        score+=90;
        reasons.push("stark zum Bewirten und Servieren");
      }

      if(state.mode==="steakburger"&&has(t,[
        "steak","burger","steakbrett","burgerbrett",
        "saftrille","aussparung","fingerfood"
      ])){
        score+=120;
        reasons.push("passt zu Burgern, Steaks und Tischmomenten");
      }

      if(state.mode==="catering"&&has(t,[
        "catering","gastro","gastronomie","buffet",
        "caterboard","servierbrett","snackboard"
      ])){
        score+=95;
        reasons.push("sinnvoll für Buffet, Gäste und Präsentation");
      }

      if(state.mode==="chefstation"&&has(t,[
        "chefstation","arbeitsstation","gn","auffangschale",
        "behälter","behaelter","konsole"
      ])){
        score+=100;
        reasons.push("hilft beim Sammeln und Organisieren direkt am Brett");
      }

      if(state.use==="kueche"&&has(t,[
        "küche","kueche","alltag","chefbrett",
        "schneidebrett","allrounder","40x30","50x30"
      ])){
        score+=45;
        reasons.push("passt zu Gemüse, Fleisch und Küchenalltag");
      }

      if(state.use==="fleisch"&&has(t,[
        "fleisch","steak","tranchieren","saftrille",
        "bbq","schneidebrett","pitmaster"
      ])){
        score+=55;
        reasons.push("gut für Fleisch und saftiges Schnittgut");
      }

      if(state.use==="bbqcuts"&&has(t,[
        "brisket","pulled pork","bbq","60x40",
        "70x40","80x40","xxl","pitmaster"
      ])){
        score+=80;
        reasons.push("genug Fläche für Brisket, Pulled Pork und große Cuts");
      }

      if(state.use==="burger"&&has(t,[
        "burger","fingerfood","snack","pommes","dip",
        "sauce","ausfräsung","ausfraesung","steakbrett","burgerbrett"
      ])){
        score+=85;
        reasons.push("passt zu Burgern, Fingerfood und Snacks");
      }

      if(state.use==="antipasti"&&has(t,[
        "käse","kaese","antipasti","brotzeit","servieren",
        "servierbrett","caterboard","snackboard","buffet"
      ])){
        score+=85;
        reasons.push("ideal für Käse, Antipasti und Brotzeit");
      }

      if(state.use==="gemischt"&&has(t,[
        "allrounder","chefbrett","schneidebrett",
        "servieren","bbq","40x30","50x30","60x40"
      ])){
        score+=45;
        reasons.push("vielseitig einsetzbar für Küche, Grill und Tisch");
      }

      if(
        p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq" &&
        (state.mode==="steakburger"||state.use==="burger")
      ){
        score+=460;
        reasons.push("passt genau zu Steak, Burger und dem Servieren am Tisch");
      }

      if(
        p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq" &&
        state.guests==="klein" &&
        (state.mode==="steakburger"||state.use==="burger")
      ){
        score+=180;
        reasons.push("für 2–4 Personen kannst du die passende Anzahl Bretter wählen");
      }

      if(
        p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq" &&
        state.guests==="familie" &&
        (state.mode==="steakburger"||state.use==="burger")
      ){
        score+=170;
        reasons.push("für mehrere Personen einfach die passende Anzahl Bretter auswählen");
      }

      if(
        p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq" &&
        state.feature==="saftrille" &&
        (state.mode==="steakburger"||state.use==="burger")
      ){
        score+=150;
        reasons.push("Saftrille passt perfekt zu Steak und Fleischsaft");
      }

      if(
        p.collection==="pitmaster-board-xxl-servierbrett-fleischbrett-bbq" &&
        (state.mode==="bbq"||state.use==="bbqcuts"||state.guests==="gross")
      ){
        score+=380;
        reasons.push("Pitmaster Board passt besonders gut zu großen Cuts, Fleisch und BBQ-Runden");
      }

      if(
        p.collection==="pitmaster-board-xxl-servierbrett-fleischbrett-bbq" &&
        state.mode==="bbq" &&
        state.use==="bbqcuts"
      ){
        score+=280;
        reasons.push("für Brisket, Pulled Pork und große Fleischstücke besonders passend");
      }

      if(
        p.collection==="chefbrett-schneidebrett-massivholz-saftrille" &&
        (
          state.mode==="bbq" ||
          state.use==="bbqcuts" ||
          state.use==="fleisch" ||
          state.guests==="gross"
        )
      ){
        score+=150;
        reasons.push("großes Chefbrett als starke Schneidebrett-Alternative");
      }

      if(
        p.collection==="caterboard-servierbrett-kaese-antipasti-bbq" &&
        (
          state.mode==="servieren" ||
          state.mode==="catering" ||
          state.use==="antipasti"
        )
      ){
        score+=260;
        reasons.push("CaterBoard passt besonders gut zu Gästen und Antipasti");
      }

      if(
        p.collection==="chefstation-schneidebrett-arbeitsstation-bbq" &&
        (state.mode==="chefstation"||state.feature==="schalen")
      ){
        score+=240;
        reasons.push("Chefstation passt perfekt, wenn Zutaten direkt am Brett gesammelt werden sollen");
      }

      if(state.guests==="solo"&&has(t,[
        "30x30","35x25","40x30","kompakt"
      ])){
        score+=30;
      }

      if(state.guests==="klein"&&has(t,[
        "40x30","46x32","50x30","allrounder"
      ])){
        score+=35;
      }

      if(state.guests==="familie"&&has(t,[
        "50x40","60x30","60x40","family",
        "xxl","caterboard","servierbrett"
      ])){
        score+=42;
      }

      if(state.guests==="gross"&&has(t,[
        "60x40","70x40","80x40","xxl","xxxl",
        "pitmaster","catering","caterboard","buffet"
      ])){
        score+=65;
      }

      if(state.feature==="saftrille"&&has(t,["saftrille"])){
        score+=55;
        reasons.push("die Saftrille hält Fleischsaft auf dem Brett");
      }

      if(state.feature==="tragen"&&has(t,[
        "griff","griffmulde","metallgriffe","griffe"
      ])){
        score+=55;
        reasons.push("lässt sich leichter tragen und bewegen");
      }

      if(state.feature==="dips"&&has(t,[
        "ausfräsung","ausfraesung","aussparung","dip",
        "dips","sauce","saucen","pommes","snack"
      ])){
        score+=70;
        reasons.push("bietet Platz für Dips, Saucen oder Beilagen");
      }

      if(state.feature==="schalen"&&has(t,[
        "gn","chefstation","arbeitsstation","auffangschale",
        "behälter","behaelter","konsole"
      ])){
        score+=90;
        reasons.push("Zutaten können direkt am Brett gesammelt werden");
      }

      if(state.feature==="egal"){
        score+=10;
      }

      if(has(t,["eiche","nussbaum"])){
        score+=10;
      }

      if(has(t,[
        "massivholz",
        "aus einem stück",
        "aus einem stueck"
      ])){
        score+=8;
      }

      return{
        product:p,
        score:score,
        reasons:reasons.slice(0,4)
      };
    }

    function chipHtml(p){
      var arr=[];

      if(p.size){
        arr.push(p.size);
      }

      if(p.wood){
        arr.push(p.wood);
      }

      if(p.collectionLabel){
        arr.push(p.collectionLabel);
      }

      if(!arr.length){
        return"";
      }

      return(
        '<div class="wm-alt-card__chips">'+
          arr.map(function(c){
            return'<span>'+esc(c)+'</span>';
          }).join("")+
        '</div>'
      );
    }

    function advisorHtml(p){
      var personen=metaText(p.personen);
      var bretttyp=metaText(p.bretttyp);
      var besteWahl=metaText(p.besteWahl);

      if(!personen&&!bretttyp&&!besteWahl){
        return"";
      }

      var html='<div class="wm-product__advisor">';

      if(personen){
        html+=
          '<div class="wm-product__advisor-item">'+
            '<span class="wm-product__advisor-icon" aria-hidden="true">'+
              '<svg viewBox="0 0 24 24">'+
                '<circle cx="8" cy="8" r="3"></circle>'+
                '<circle cx="16.5" cy="9" r="2.5"></circle>'+
                '<path d="M3.5 19c.4-4.2 2.2-6.2 4.5-6.2s4.1 2 4.5 6.2"></path>'+
                '<path d="M13 14c1-.8 2.1-1.2 3.4-1.2 2.3 0 4 2 4.3 5.2"></path>'+
              '</svg>'+
            '</span>'+
            '<span class="wm-product__advisor-copy">'+
              '<small>Anzahl Personen</small>'+
              '<strong>'+esc(personen)+'</strong>'+
            '</span>'+
          '</div>';
      }

      if(bretttyp){
        html+=
          '<div class="wm-product__advisor-item">'+
            '<span class="wm-product__advisor-icon" aria-hidden="true">'+
              '<svg viewBox="0 0 24 24">'+
                '<rect x="4" y="5" width="16" height="14" rx="1"></rect>'+
                '<path d="M8 9h8"></path>'+
                '<path d="M8 13h5"></path>'+
              '</svg>'+
            '</span>'+
            '<span class="wm-product__advisor-copy">'+
              '<small>Bretttyp</small>'+
              '<strong>'+esc(bretttyp)+'</strong>'+
            '</span>'+
          '</div>';
      }

      if(besteWahl){
        html+=
          '<div class="wm-product__advisor-item wm-product__advisor-item--wide">'+
            '<span class="wm-product__advisor-icon" aria-hidden="true">'+
              '<svg viewBox="0 0 24 24">'+
                '<path d="M12 3.5l2.5 5.1 5.6.8-4 3.9.9 5.5-5-2.6-5 2.6.9-5.5-4-3.9 5.6-.8z"></path>'+
              '</svg>'+
            '</span>'+
            '<span class="wm-product__advisor-copy">'+
              '<small>Beste Wahl für</small>'+
              '<strong>'+esc(besteWahl)+'</strong>'+
            '</span>'+
          '</div>';
      }

      html+='</div>';

      return html;
    }

    function productCard(r){
      var p=r.product;

      var reasons=r.reasons.length
        ?r.reasons
        :[
          "passt zu deiner Auswahl",
          "sinnvolle Empfehlung aus dem wood & more Sortiment"
        ];

      return(
        '<a class="wm-product wm-product--finder" href="'+p.url+'">'+
          '<div class="wm-product__media">'+
            (
              p.image
                ?'<img class="wm-product__img" src="'+p.image+'" alt="'+esc(p.title)+'" loading="lazy">'
                :''
            )+
          '</div>'+

          '<div class="wm-product__meta">'+
            '<div class="wm-product__kicker">Meine Empfehlung</div>'+
            '<div class="wm-product__label">Warum dieses Brett?</div>'+
            '<div class="wm-product__title">'+esc(p.title)+'</div>'+
            '<div class="wm-product__price">'+money(p.price)+'</div>'+
            chipHtml(p)+
            advisorHtml(p)+
            '<div class="wm-product__reasons">'+
              reasons.map(function(x){
                return'<span>'+esc(x)+'</span>';
              }).join("")+
            '</div>'+
            '<span class="wm-product__chip">Dieses Brett ansehen</span>'+
          '</div>'+
        '</a>'
      );
    }

    function altCard(label,r){
      var p=r.product;

      return(
        '<a class="wm-alt-card" href="'+p.url+'">'+
          '<div class="wm-alt-card__img">'+
            (
              p.image
                ?'<img src="'+p.image+'" alt="'+esc(p.title)+'" loading="lazy">'
                :''
            )+
          '</div>'+

          '<div class="wm-alt-card__content">'+
            '<strong>'+esc(label)+'</strong>'+
            chipHtml(p)+
            '<span class="wm-alt-card__title">'+esc(p.title)+'</span>'+
            advisorHtml(p)+
            '<em>Ansehen</em>'+
          '</div>'+
        '</a>'
      );
    }

    function pickAlternative(ranked,best,collection){
      return ranked.find(function(r){
        return(
          r.product.handle!==best.product.handle &&
          r.product.collection===collection
        );
      });
    }

    function getAltLabel(p,best){
      if(p.collection==="holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq"){
        if(state.guests==="klein"){
          return"Für 2–4 Personen passend";
        }

        if(state.guests==="familie"){
          return"Als Set für Familie & Freunde";
        }

        if(state.guests==="gross"){
          return"Mehrere Bretter für große Runden";
        }

        return"Für Burger & Steaks";
      }

      if(best){
        var bestArea=best.product.area||0;
        var area=p.area||0;

        if(area&&bestArea&&area>bestArea*1.18){
          return"Größer: "+p.size;
        }

        if(area&&bestArea&&area<bestArea*.82){
          return"Kompakter: "+p.size;
        }

        if(p.wood&&best.product.wood&&p.wood!==best.product.wood){
          return"Variante aus "+p.wood;
        }
      }

      if(p.collection==="caterboard-servierbrett-kaese-antipasti-bbq"){
        return"Aus der Kollektion CaterBoard";
      }

      if(p.collection==="pitmaster-board-xxl-servierbrett-fleischbrett-bbq"){
        return"Aus der Kollektion Pitmaster Board";
      }

      if(p.collection==="chefbrett-schneidebrett-massivholz-saftrille"){
        return"Aus der Kollektion Chefbrett";
      }

      if(p.collection==="chefstation-schneidebrett-arbeitsstation-bbq"){
        return"Als Arbeitsstation";
      }

      return"Weitere passende Variante";
    }

    function buildAlternatives(ranked,best){
      var selected=[];
      var used={};

      used[best.product.handle]=true;

      function add(label,item){
        if(!item||used[item.product.handle]){
          return;
        }

        used[item.product.handle]=true;

        selected.push({
          label:label,
          result:item
        });
      }

      if(state.mode==="steakburger"||state.use==="burger"){
        add(
          "Für Burger & Steaks",
          pickAlternative(
            ranked,
            best,
            "holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq"
          )
        );

        add(
          "Massives Chefbrett dazu",
          pickAlternative(
            ranked,
            best,
            "chefbrett-schneidebrett-massivholz-saftrille"
          )
        );

        add(
          "Für größere BBQ-Stücke",
          pickAlternative(
            ranked,
            best,
            "pitmaster-board-xxl-servierbrett-fleischbrett-bbq"
          )
        );
      }

      if(
        state.mode==="bbq" ||
        state.use==="bbqcuts" ||
        state.guests==="gross"
      ){
        add(
          "Aus der Kollektion Pitmaster Board",
          pickAlternative(
            ranked,
            best,
            "pitmaster-board-xxl-servierbrett-fleischbrett-bbq"
          )
        );

        add(
          "Großes Chefbrett als Alternative",
          pickAlternative(
            ranked,
            best,
            "chefbrett-schneidebrett-massivholz-saftrille"
          )
        );

        add(
          "Für Gäste & Servieren",
          pickAlternative(
            ranked,
            best,
            "caterboard-servierbrett-kaese-antipasti-bbq"
          )
        );
      }

      if(
        state.mode==="servieren" ||
        state.use==="antipasti" ||
        state.mode==="catering"
      ){
        add(
          "Aus der Kollektion CaterBoard",
          pickAlternative(
            ranked,
            best,
            "caterboard-servierbrett-kaese-antipasti-bbq"
          )
        );

        add(
          "Massives Schneidebrett dazu",
          pickAlternative(
            ranked,
            best,
            "chefbrett-schneidebrett-massivholz-saftrille"
          )
        );

        add(
          "Für große BBQ-Runden",
          pickAlternative(
            ranked,
            best,
            "pitmaster-board-xxl-servierbrett-fleischbrett-bbq"
          )
        );
      }

      if(
        state.mode==="chefstation" ||
        state.feature==="schalen"
      ){
        add(
          "Als Arbeitsstation",
          pickAlternative(
            ranked,
            best,
            "chefstation-schneidebrett-arbeitsstation-bbq"
          )
        );

        add(
          "Klassisches Chefbrett",
          pickAlternative(
            ranked,
            best,
            "chefbrett-schneidebrett-massivholz-saftrille"
          )
        );

        add(
          "Zum Servieren dazu",
          pickAlternative(
            ranked,
            best,
            "caterboard-servierbrett-kaese-antipasti-bbq"
          )
        );
      }

      ranked.forEach(function(r){
        if(selected.length>=6){
          return;
        }

        add(getAltLabel(r.product,best),r);
      });

      return selected.slice(0,6);
    }

    function render(){
      if(!ready()){
        wrap.innerHTML=
          '<div class="wm-note">'+
            'Wähle bitte die ersten vier Punkte aus. Danach kann ich dir ein sinnvolles Brett empfehlen.'+
          '</div>';

        return;
      }

      wrap.innerHTML=
        '<div class="wm-note">'+
          'Produkte werden geladen …'+
        '</div>';

      loadProducts()
        .then(function(){
          if(!products.length){
            wrap.innerHTML=
              '<div class="wm-note">'+
                'Es wurden keine Produkte geladen. Prüfe bitte, ob die Collection-Handles im Code exakt stimmen.'+
              '</div>';

            return;
          }

          var ranked=products
            .map(scoreProduct)
            .sort(function(a,b){
              return b.score-a.score;
            });

          var best=ranked[0];

          wrap.innerHTML=productCard(best);

          var alternatives=buildAlternatives(ranked,best);

          altWrap.innerHTML=alternatives
            .map(function(item){
              return altCard(item.label,item.result);
            })
            .join("");

          altWrap.hidden=alternatives.length===0;

          summary.textContent=
            "Basierend auf deinen Antworten haben wir passende Bretter aus dem wood & more Sortiment bewertet.";

          note.hidden=false;

          if(
            best.product.collection===
            "holzbretter-fuer-burger-steaks-handgefertigt-aus-massivholz-fur-bbq"
          ){
            note.innerHTML=
              '<strong>Hinweis:</strong> Bei Steak- und Burgerbrettern geht es nicht um ein größeres Brett für mehrere Personen, sondern um die passende Anzahl. Für 2–4 Personen wählst du einfach die entsprechende Menge oder Set-Variante.'+
              '<br><br>'+
              '<strong>Optional:</strong> Viele Bretter kannst du zusätzlich gravieren lassen – ideal als Geschenk, für BBQ-Teams, Firmen oder besondere Anlässe.';
          }else{
            note.innerHTML=
              'Wir zeigen dir nicht nur den engsten Treffer, sondern öffnen darunter bewusst den Blick: größeres Brett, kompaktere Variante, andere Holzart oder andere Kollektion können je nach Einsatz sinnvoll sein.'+
              '<br><br>'+
              '<strong>Optional:</strong> Viele Bretter kannst du zusätzlich gravieren lassen – ideal als Geschenk, für BBQ-Teams, Firmen oder besondere Anlässe.';
          }

          var resultSection=root.querySelector("#wm-finder-result");

          if(resultSection){
            resultSection.scrollIntoView({
              behavior:"smooth",
              block:"start"
            });
          }
        })
        .catch(function(error){
          console.error("Brett-Finder Fehler:",error);

          wrap.innerHTML=
            '<div class="wm-note">'+
              'Die Empfehlungen konnten gerade nicht geladen werden. Bitte versuche es erneut.'+
            '</div>';
        });
    }

    showBtn.addEventListener("click",render);

    resetBtn.addEventListener("click",function(){
      state={
        mode:null,
        use:null,
        guests:null,
        feature:null,
        wood:"egal"
      };

      root
        .querySelectorAll("button.wm-choice")
        .forEach(function(el){
          el.setAttribute("aria-pressed","false");
        });

      wrap.innerHTML="";
      altWrap.innerHTML="";
      altWrap.hidden=true;

      note.hidden=true;
      note.textContent="";

      summary.textContent=
        "Wähle oben deine Antworten – dann zeigen wir dir ein passendes Brett.";

      update();
    });

    update();
  }

  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",boot);
  }else{
    boot();
  }
})();